import { CobaltActionBar } from '@cae/cobalt-react/components/action-bar';
import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltLoaderCircular } from '@cae/cobalt-react/components/loader-circular';
import * as React from 'react';

import type { EditOtherInformationActionBarProps } from './EditOtherInformationActionBar.types';

const EditOtherInformationActionBar = React.memo(
  ({
    isMobile,
    isPending,
    isProfileReady,
    isDirty,
    onCloseAttempt,
    onSubmit,
  }: Readonly<EditOtherInformationActionBarProps>): React.ReactElement => (
    <CobaltActionBar
      position="right"
      variant="floating"
      mobile={isMobile}
      data-heap-id="edit-other-information-action-bar"
      secondaryButton={
        <CobaltButton
          data-heap-id="profile-other-info-cancel-btn"
          variant="secondary"
          onClick={onCloseAttempt}
          disabled={isPending}
        >
          Cancel
        </CobaltButton>
      }
      primaryButton={
        <CobaltButton
          data-heap-id="profile-other-info-save-btn"
          variant="primary"
          onClick={onSubmit}
          disabled={isPending || !isProfileReady || !isDirty}
        >
          Save{isPending && <CobaltLoaderCircular size="small" />}
        </CobaltButton>
      }
    />
  )
);

EditOtherInformationActionBar.displayName = 'EditOtherInformationActionBar';

export { EditOtherInformationActionBar };
